/* eslint-disable camelcase */
import { useEffect } from 'react';
import { analytics } from '@eti/utils';
import { dialogStates } from '../../../../pages/payment/constants/paymentDialog';
import { makeOrderResponseMessages } from '../../../../pages/payment/constants/makeOrderResponse';
import type { PageTypeDetails, PageTypeProperties } from '../models';
import { getResponsivePageViewEvent } from '../../dataLayer';

const {
  DECLINED_BY_BANK,
  GENERIC_ERROR,
  MISSING_ERROR,
  NOT_ENOUGH_FUNDS,
  PAYMENT_DETAILS_ERROR,
  PRECONDITIONS_VALIDATION_FAILED,
  TECHNICAL_ERROR,
  THREE_D_FAILURE,
  USE_ANOTHER_CARD,
  CART_RESTART_FROM_SEARCH,
  PRICE_CHANGE_SHOW_CUSTOMER,
  CART_FAIL_CART,
} = makeOrderResponseMessages;

const pageTypeDetails: PageTypeDetails = {
  [DECLINED_BY_BANK]: 'Error - Bank decline',
  [GENERIC_ERROR]: 'Error - Generic message',
  [MISSING_ERROR]: 'Error - Generic message',
  [NOT_ENOUGH_FUNDS]: 'Error - No funds or limits exceeded',
  [PAYMENT_DETAILS_ERROR]: 'Error - Check payment details',
  [PRECONDITIONS_VALIDATION_FAILED]: 'Error - Number of attempts',
  [TECHNICAL_ERROR]: 'Error - Technical error',
  [THREE_D_FAILURE]: 'Error - 3D failure',
  [USE_ANOTHER_CARD]: 'Error - Use another card or payment method',
  [CART_RESTART_FROM_SEARCH]: 'Error - Invalid Trip. Go back to Search',
  [PRICE_CHANGE_SHOW_CUSTOMER]: 'Error - Price change',
  [CART_FAIL_CART]: 'Error - Invalid Cart',
};

const isLastEventDuplicate = (pageTypeDetailed: string) => {
  const { dataLayer } = window;
  if (!dataLayer) {
    return false;
  }
  const lastDataLayerEvent = dataLayer[dataLayer.length - 1];
  return lastDataLayerEvent?.page_type_detailed === pageTypeDetailed;
};
export const usePaymentErrorDataLayerEffect = (
  dialogState: string | null,
  errorMessageId: PageTypeProperties,
) => {
  const { TRANSITION, ERROR } = dialogStates;

  useEffect(() => {
    if (dialogState === TRANSITION && !isLastEventDuplicate('Transition')) {
      analytics.pushEntryToDataLayer(
        getResponsivePageViewEvent('/payment', 'Payment', 'Transition'),
        true,
      );
    } else if (
      dialogState === ERROR &&
      errorMessageId &&
      !isLastEventDuplicate(pageTypeDetails[errorMessageId])
    ) {
      analytics.pushEntryToDataLayer(
        getResponsivePageViewEvent('/payment', 'Payment', `${pageTypeDetails[errorMessageId]}`),
      );
    }
  }, [ERROR, TRANSITION, dialogState, errorMessageId]);
};
